"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = insertAfter;
function insertAfter(node, _ref) {
  var nextSibling = _ref.nextSibling,
      parentNode = _ref.parentNode;

  return parentNode.insertBefore(node, nextSibling);
}
module.exports = exports['default'];
